import React, { Suspense } from "react";

// Recoil
import { useSetRecoilState } from "recoil";
import { snackBarState } from "recoil/globalStates";

// Import components
import { Container } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";

// Local components
import Footer from "components/Footer";
import ScrollToTop from "components/ScrollToTop";
import { GlobalError } from "elements/alerts";
import { LoaderOverlay } from "elements/Loader";
import { SnackbarManager } from "elements/SnackbarManager";

import { AppRoutes } from "routes";

export default function App() {
  const setSnackbarState = useSetRecoilState(snackBarState);

  const logError = (error) => {
    console.log("App caught an error", error);
    setSnackbarState({
      message: error.message,
      severity: "error",
      open: true,
    });
  };

  return (
    <>
      <ErrorBoundary FallbackComponent={GlobalError} onError={logError}>
        <Container disableGutters sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 0 } }} as="main" className="content">
          <AppRoutes />
        </Container>
        <Footer />
      </ErrorBoundary>
      {/* Global overlays: outside ErrorBoundary so they survive route render errors */}
      <ScrollToTop />
      <LoaderOverlay />
      <SnackbarManager />
    </>
  );
}
